import React from 'react';
import { Phone, ChevronDown } from 'lucide-react';
import { restaurantInfo } from '../data/mockData';
import { Badge } from './ui/badge';
import { DeliveryLogos } from './DeliveryLogos';

export const Hero = () => {
  const scrollToMenu = (e) => {
    e.preventDefault();
    const menuSection = document.querySelector('#menu');
    if (menuSection) {
      const offset = 80;
      const elementPosition = menuSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1706713417278-f56e1fd147e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxkYXJrJTIwd29vZCUyMGZsYW1lc3xlbnwwfHx8fDE3NjI4NzcwMjh8MA&ixlib=rb-4.1.0&q=85)'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        {/* Logo */}
        <div className="mb-12 flex justify-center">
          <img
            src="https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/vazkxwl7_ChatGPT%20Image%2011%20nov.%202025%2C%2016_51_57.png"
            alt="L'Original Logo"
            className="w-3/5 h-auto"
          />
        </div>

        {/* Main Title */}
        <h1
          className="text-5xl md:text-7xl font-bold text-white mb-6"
          style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
        >
          L'Original – {restaurantInfo.location}
        </h1>

        {/* Tagline */}
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed">
          {restaurantInfo.tagline}
        </p>

        {/* Badges */}
        <div className="flex justify-center gap-3 mb-10">
          {restaurantInfo.badges.map((badge, index) => (
            <Badge
              key={index}
              variant="secondary"
              className="bg-[#ECEC75] text-black text-sm px-4 py-1.5 font-semibold"
            >
              {badge}
            </Badge>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href={restaurantInfo.phoneLink}
            className="inline-flex items-center gap-2 bg-[#D4A85F] text-black px-8 py-4 rounded-md font-bold text-lg hover:bg-[#E2B978] transition-all duration-200 hover:transform hover:-translate-y-1 hover:shadow-2xl w-full sm:w-auto justify-center"
          >
            <Phone size={20} />
            Appeler maintenant
          </a>
          <a
            href="#menu"
            onClick={scrollToMenu}
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-white hover:text-black transition-all duration-200 hover:transform hover:-translate-y-1 w-full sm:w-auto justify-center"
          >
            Voir le menu
          </a>
        </div>

        {/* Delivery Logos */}
        <div className="mb-8">
          <p className="text-white text-center mb-4 font-semibold">Commandez en ligne :</p>
          <DeliveryLogos variant="hero" />
        </div>

        {/* Quick Info */}
        <div className="text-white space-y-2">
          <p className="text-lg font-medium">
            <a href={restaurantInfo.phoneLink} className="hover:text-[#ECEC75] transition-colors">
              {restaurantInfo.phoneDisplay}
            </a>
          </p>
          <p className="text-sm text-gray-300">
            Lun: Fermé | Mar-Jeu: 11:00–15:00, 18:00–23:00 | Ven-Dim: 11:00–23:00
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white" size={32} />
      </div>
    </section>
  );
};
